import Vue from "vue"
import { AclInstaller, AclCreate, AclRule } from "vue-acl"
import router from "@/router"

Vue.use(AclInstaller)

let initialRole = "admin"

//let userInfo = JSON.parse(localStorage.getItem("userInfo"))
//if(userInfo && userInfo.userRole) initialRole = userInfo.userRole

export default new AclCreate({
  initial: initialRole,
  notfound: "/pages/not-authorized",
  router,
  //acceptLocalRules: true,
  globalRules: {
    admin: new AclRule("admin").generate(),
    general: new AclRule("wl_general").or("general").or("admin").generate(),
    directors: new AclRule("directors").or("wl_general").or("general").or("admin").generate(),    
    public: new AclRule("public").or("directors").or("admin").or("general").or("wl_general").generate(),
  }
})
